// removed by extract-text-webpack-plugin
module.exports = {"services":"XRY48fqsgTtnbYHj08cFB_0","item":"_2VB3teWQMBMmZ4YH4v8mM0_0","title":"_3IPGFZVs4rnPlQEeTtTuYw_0","description":"_1py81QRhnw12TqIdLHVy0e_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-99da7564!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Services.vue
// module id = 64
// module chunks = 2